import styles from './index.module.sass';
import { useHistory, useLocation } from 'react-router-dom';
import Lottie from 'react-lottie';
import main from 'assets/icon-tab-main.svg';
import map from 'assets/icon-tab-map.svg';
import orders from 'assets/icon-tab-orders.svg';
import points from 'assets/icon-tab-points.svg';
import mainActive from 'lottie/tab-main.json';
import mapActive from 'lottie/tab-maps.json';
import ordersActive from 'lottie/tab-orders.json';
import pointsActive from 'lottie/tab-coins.json';
import { useEffect, useState } from 'react';
import { useAppContext, SHOW_TOAST_MESSAGE, SET_LINE_BANK_LOGIN_DIALOG } from 'use-app';
import { PATH, isLineBank } from 'config';
import { getLoginState } from 'model/user';
import amplitude from 'service/amplitude';

const BottomTab = ({ tabs }) => {
  const setTab = () => {
    switch (location.pathname) {
      case PATH.COINS:
        return 'coins';
      case PATH.MAPS:
        return 'maps';
      case PATH.ORDERS:
      case PATH.ORDER_DETAIL:
        return 'orders';
      default:
        return 'main';
    }
  };
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState(setTab);
  const history = useHistory();
  const { dispatch: appDispatch } = useAppContext();
  const loginState = getLoginState();
  const isUser = loginState === 'user';
  const exceptionPath = ['user', 'expired'];

  useEffect(() => {
    setCurrentTab(setTab());
  }, [location.pathname]); // eslint-disable-line

  if (exceptionPath.find(path => location.pathname.includes(path))) return <></>;

  const tabsGroup = {
    main: {
      icon: main,
      iconActive: mainActive,
      name: '行車錢包',
      link: PATH.MAIN,
      amplitudeEvent: amplitude.tab_main_onClick,
    },
    maps: {
      icon: map,
      iconActive: mapActive,
      name: '場站地圖',
      link: PATH.MAPS,
      amplitudeEvent: amplitude.tab_maps_onClick,
    },
    orders: {
      icon: orders,
      iconActive: ordersActive,
      name: '消費紀錄',
      link: PATH.ORDERS,
      amplitudeEvent: amplitude.tab_orders_onClick,
    },
    coins: {
      icon: points,
      iconActive: pointsActive,
      name: '行車幣',
      link: PATH.COINS,
      amplitudeEvent: amplitude.tab_coins_onClick,
    },
  };

  return (
    <ul className={styles['menu-tab']}>
      {tabs.map(tab => {
        const tabContent = tabsGroup[tab];
        const isActive = currentTab === tab;
        return (
          <li
            className={isActive ? `${styles.active}` : ''}
            key={tab}
            onClick={() => {
              tabContent.amplitudeEvent();
              if (tab === 'orders' || tab === 'coins') {
                const linkToLogin = () => {
                  appDispatch({
                    type: SHOW_TOAST_MESSAGE,
                    payload: '請先登入再繼續',
                  });
                  history.push(PATH.USER_LOGIN);
                };

                if (isUser) {
                  return history.push(tabContent.link);
                } else {
                  if (isLineBank) {
                    appDispatch({ type: SET_LINE_BANK_LOGIN_DIALOG });
                  } else {
                    linkToLogin();
                  }
                }
              } else {
                history.push(tabContent.link);
              }
            }}
          >
            {isActive ? (
              <Lottie
                width={23}
                height={23}
                options={{
                  loop: false,
                  animationData: tabContent.iconActive,
                }}
              />
            ) : (
              <img src={tabContent.icon} alt="icon" />
            )}
            <span>{tabContent.name}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default BottomTab;
